export default __webpack_public_path__ + "static/rocket8-09ad238386aee6b2fbb554c33db14c35.png";